import "../../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import { withContainerContext } from "../../../components/container/ContainerContext";
import FormRadio from "../../../components/form/FormRadio";
import ModalCheckboxGrid from "../../../components/modal/ModalCheckboxGrid";
import ModalDescription from "../../../components/modal/ModalDescription";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import { PropTypeShapes } from "../../../types";

const renderNarrativeGroup = useProps => {
  return (
    <ModalGroup key="narrativeGroup">
      <ModalRow key="description">
        <ModalDescription>
          <span>Aeon Timeline now supports two different types of constraints.</span>
        </ModalDescription>
      </ModalRow>
      <ModalRow key="fieldLabel">
        <ModalDescription>
          <span>Import events based on other events as:</span>
        </ModalDescription>
      </ModalRow>
      <ModalRow key="fields">
        <ModalField>
          <div className="fullWidthOptions">
            <ModalCheckboxGrid>
              <FormRadio
                key="constraints"
                label="Date Constraints"
                subLabel="Link items together with a fixed, optional amount of time between them, e.g. A
              starts exactly 5 days after B"
                isChecked={useProps.createConstraintsFromV2Dependencies}
                onChange={newState => useProps.onDependenciesChange(newState)}
              />
              <FormRadio
                key="dependencies"
                label="Dependencies"
                subLabel="Order items in relation to each other but do not lock them to dates, e.g. A can start anytime after B."
                isChecked={!useProps.createConstraintsFromV2Dependencies}
                onChange={newState => useProps.onDependenciesChange(!newState)}
              />
            </ModalCheckboxGrid>
          </div>
        </ModalField>
      </ModalRow>
    </ModalGroup>
  );
};

const DependenciesPage = props => {
  return [renderNarrativeGroup(props)];
};

DependenciesPage.propTypes = {
  createConstraintsFromV2Dependencies: PropTypes.bool.isRequired,
  onDependenciesChange: PropTypes.func.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withContainerContext(DependenciesPage);
